const courseLinks = [
  { label: 'ChatGPT Mastery', href: '/courses/chatgpt-mastery' },
  { label: 'ML Foundations', href: '/courses/ml-foundations' },
  { label: 'AI Agents', href: '/courses/ai-agents' },
  { label: 'AI for Developers', href: '/courses/ai-for-devs' },
];

const companyLinks = [
  { label: 'About', href: '/' },
  { label: 'Pricing', href: '/pricing' },
  { label: 'Contact', href: '/contact' },
  { label: 'Checkout', href: '/checkout' },
];

const supportLinks = [
  { label: 'Pricing', href: '/pricing' },
  { label: 'Refund Policy', href: '/refund-policy' },
  { label: 'Terms of Service', href: '/terms-of-service' },
  { label: 'Contact', href: '/contact' },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-foreground-400 py-14 md:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-10 md:mb-12">
          {/* Brand */}
          <div className="col-span-1">
            <div className="flex items-center gap-2 font-bold text-xl text-background-50 mb-4">
              <div className="w-20 h-20 flex items-center justify-center overflow-hidden">
                <img
                  alt="ggcourse"
                  className="w-full h-full object-contain"
                  src="https://static.readdy.ai/image/b83b8b9a8d6ac616d68701c8b393b970/6b0747328001cf5b1e1edeec1877761c.png"
                />
              </div>
              <span className="font-heading">ggcourse</span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed">
              AIVO SOLUTION SDN BHD — Expert AI education for the next generation of developers, engineers, and builders.
            </p>
          </div>

          {/* Courses */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider mb-4">
              Courses
            </h4>
            <ul className="space-y-2">
              {courseLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-500 hover:text-background-50 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider mb-4">
              Company
            </h4>
            <ul className="space-y-2">
              {companyLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-500 hover:text-background-50 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider mb-4">
              Support
            </h4>
            <ul className="space-y-2">
              {supportLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-500 hover:text-background-50 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-foreground-800 pt-6 md:pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-600">
            &copy; 2026 AIVO SOLUTION SDN BHD. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-background-50 transition-colors">
              <i className="ri-twitter-x-fill w-5 h-5 flex items-center justify-center" />
            </a>
            <a href="#" className="text-foreground-500 hover:text-background-50 transition-colors">
              <i className="ri-linkedin-fill w-5 h-5 flex items-center justify-center" />
            </a>
            <a href="#" className="text-foreground-500 hover:text-background-50 transition-colors">
              <i className="ri-github-fill w-5 h-5 flex items-center justify-center" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}